module.exports = __webpack_public_path__ + "img/france.70de774.webp";